var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7778 11.6443C22.9965 11.8428 22.9963 12.1867 22.7774 12.385L11.6168 22.4932C11.2954 22.7843 10.7811 22.5563 10.7811 22.1226L10.7809 17.0029C10.7808 16.7268 10.557 16.503 10.2809 16.503H1.25C0.973858 16.503 0.75 16.2791 0.75 16.003L0.75 8.00295C0.75 7.72681 0.973858 7.50295 1.25 7.50295H10.2815C10.5576 7.50295 10.7815 7.27908 10.7815 7.00293L10.7812 1.88162C10.7812 1.44769 11.2961 1.21972 11.6173 1.51141L22.7778 11.6443Z",
    fill: "#C7C9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.dd06f840208d2aa01718c2ce3d96e44c.svg";
export { ForwardRef as ReactComponent };